import React from 'react';
import TeachingAccordion from "../components/TeachingAccordion";

const Teaching = () => {
    return (
        <div style={{padding: "0px 30px"}}>
            <h3>Talks</h3>
            <TeachingAccordion/>
        </div>
    );
};

export default Teaching;
